import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from '../views/error/error.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import {GlobalService} from './global.service';
import {SimpleNotificationsModule} from "angular2-notifications";
import { PermissionPipe } from './permission.pipe';
import {PermissionComponent} from "./permission/permission.component";

@NgModule({
  declarations: [ErrorComponent, PermissionPipe, PermissionComponent],
  imports: [
    RouterModule,
    CommonModule,
    TranslateModule,
    PerfectScrollbarModule,
    SimpleNotificationsModule,
    SimpleNotificationsModule.forRoot(),
  ],
    exports: [
        PerfectScrollbarModule,
        RouterModule,
        ErrorComponent,
        TranslateModule,
        CommonModule,
        PermissionPipe,
    ],
  providers: [GlobalService]
})
export class SharedModule { }
